module.exports = __webpack_public_path__ + "img/15_54.483de434.png";